import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let CLIENT_ORG = "";
export const setClientOrg = (id) => { CLIENT_ORG = id || ""; };
export const clientOrgHeader = (c) => {
  if (CLIENT_ORG) c.headers["X-Client-Org"] = CLIENT_ORG;
  return c;
};
api.interceptors.request.use(clientOrgHeader);
axios.interceptors.request.use(clientOrgHeader);

const rawFetch = window.fetch.bind(window);
window.fetch = (input, init = {}) => {
  const url = typeof input === "string" ? input : input?.url || "";
  const ours = url.startsWith(process.env.REACT_APP_BACKEND_URL) || url.startsWith(window.location.origin) || url.startsWith("/api");
  if (CLIENT_ORG && ours) {
    const headers = new Headers(init.headers || (typeof input !== "string" ? input.headers : undefined));
    headers.set("X-Client-Org", CLIENT_ORG);
    return rawFetch(input, { ...init, headers });
  }
  return rawFetch(input, init);
};

axios.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    if (err.response?.status === 401 && !cfg._retry && !(cfg.url || "").includes("/auth/")) {
      cfg._retry = true;
      try {
        await axios.post(`${API}/auth/refresh`, {}, { withCredentials: true });
        return axios(cfg);
      } catch (e) {
        return Promise.reject(err);
      }
    }
    return Promise.reject(err);
  }
);

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    const url = cfg.url || "";
    const retryable = !url.includes("/auth/") || url.endsWith("/auth/me");
    if (err.response?.status === 401 && !cfg._retry && retryable) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x?.msg ? x.msg.replace(/^Value error, /, "") : JSON.stringify(x))).join(" ");
  if (d.message) return d.message;
  return String(d);
}

export const money = (n) => new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" }).format(n || 0);
export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString("en-AU", { day: "numeric", month: "short", year: "numeric" }) : "—");

export async function download(path, filename) {
  const res = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export const PLANS = {
  monthly: { label: "Monthly", months: 1, base: 100, seat: 15, period: "per month", billed: "Billed monthly" },
  six_month: { label: "Six-Month", months: 6, base: 540, seat: 90, period: "every 6 months", billed: "Paid upfront every 6 months" },
  annual: { label: "Annual", months: 12, base: 1000, seat: 180, period: "every 12 months", billed: "Paid upfront every 12 months" },
};

export function calcPrice(plan, users) {
  const p = PLANS[plan];
  const extra = Math.max(0, users - 1);
  const extraCost = extra * p.seat;
  const total = p.base + extraCost;
  const compare = (100 + extra * 15) * p.months;
  return { base: p.base, extra, extraCost, total, monthly: total / p.months, savings: compare - total, compare };
}

export function useSEO(title, description) {
  if (typeof document !== "undefined") {
    document.title = title ? `${title} | QORDEL 360` : "QORDEL 360 | Integrated Quality, Safety & Compliance Management Software";
    const m = document.querySelector('meta[name="description"]');
    if (m && description) m.setAttribute("content", description);
  }
}
